// src/app/features/pages/pages.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms'; // <--- Import

// Importa RouterModule para [routerLink]
import { RouterModule } from '@angular/router';
// Importa CarouselModule para <owl-carousel-o>
import { CarouselModule } from 'ngx-owl-carousel-o';

// Importa todos los componentes “de página”:
import { ErrorComponent } from './error/error.component';
import { HomeOneComponent } from './home-one/home-one.component';
import { AboutComponent } from './about/about.component';
import { FeaturesComponent } from './features/features.component';
import { BenefitsComponent } from './benefits/benefits.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { ContactComponent } from './contact/contact.component';
import { LoginComponent } from './login/login.component';

import { SharedModule } from './../../shared/shared.module';

@NgModule({
  declarations: [
    ErrorComponent,
    HomeOneComponent,
    AboutComponent,
    FeaturesComponent,
    BenefitsComponent,
    ScheduleComponent,
    ContactComponent,
    LoginComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    // Indispensable para que [routerLink] sea reconocido:
    RouterModule,
    // Indispensable para que <owl-carousel-o> sea reconocido:
    CarouselModule,
    SharedModule
  ],
  exports: [
    ErrorComponent,
    HomeOneComponent,
    AboutComponent,
    FeaturesComponent,
    BenefitsComponent,
    ScheduleComponent,
    ContactComponent,
    LoginComponent
  ]
})
export class PagesModule { }
